import { Component } from '@angular/core';
import { API_ENDPOINTS } from "../../constants/api-endpoints.constants";

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html'
})
export class LandingComponent {
  ngOnInit(): void {
    window.location.href = API_ENDPOINTS.authentication.signIn;
  }
}
